import { STATS } from "@/data/site";
import { useLiveStats } from "@/lib/liveStats";

const Diamond = () => (
  <span className="hidden md:inline-flex items-center justify-center text-stone-300">
    <svg viewBox="0 0 8 8" className="w-2 h-2" fill="currentColor">
      <path d="M4 0L8 4L4 8L0 4Z" />
    </svg>
  </span>
);

export default function TrustStrip() {
  const stats = useLiveStats();

  // Replace the static "Five-star reviews" count with the live total.
  const items = STATS.map((s) =>
    /five-star/i.test(s.label)
      ? { ...s, value: String(stats.total) }
      : s
  );

  return (
    <section className="bg-stone-50 py-16 md:py-24">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-10 md:gap-6">
          {items.map((s, i) => (
            <div key={s.label} className="flex items-center gap-6">
              <div
                className="text-center md:text-left"
                data-testid={`trust-stat-${i}`}
              >
                <p className="font-serif text-[2.6rem] md:text-5xl text-stone-900 kbd leading-none">
                  {s.value}
                </p>
                <p className="mt-3 font-serif italic text-stone-500 text-base">
                  {s.label}
                </p>
              </div>
              {i !== items.length - 1 && <Diamond />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
